export interface AuthDto {
	username: string;
	password?: string;
	otp?: string;
	otpRequired?: boolean;
	user?: UserDto;
	token?: string;
	success?: boolean;
	error?: string;
}

export enum UserStatusEnum {
	Active = 'Active',
	Blocked = 'Blocked',
	Disabled = 'Disabled',
	New = 'New'
}

export interface UserDto {
	id?: number;
	createdAt?: Date;
	username?: string;
	password?: string;
	name?: string;
	surname?: string;
	email?: string;
	status?: UserStatusEnum;
	tempPassword?: boolean;
	forceChangePassword?: boolean;
}
export interface PermissionDto {
	id?: number;
	permission?: string;
	type?: PermissionTypeEnum;
	category?: string;
	description?: string;
}

export enum PermissionTypeEnum {
	Gui = "Gui"
}

export enum PermissionEnum {
	UsersView = "Users View",
    UsersEdit = "Users Edit",
    UsersAdd = "Users Add",
    
    // Products
    ProductsView = "Products View",
    ProductsEdit = "Products Edit",
    ProductsAdd = "Products Add",
    
    // Packages
    PackagesView = "Packages View",
    PackagesEdit = "Packages Edit",
    PackagesAdd = "Packages Add",

    // SDKs
    SdksView = "SDKs View",
    SdksEdit = "SDKs Edit",
    SdksAdd = "SDKs Add",

    // Email
    EmailView = "Email View",
    EmailCompose = "Email Compose",

    // Files
    FilesBrowse = "Files Browse",
    FilesPackage = "Files Package",
}

export interface SignInOutcome {
	success: boolean;
	error: any;
}

export interface ResponseDto {
	success: boolean;
	error: string;
	errors?: string[];
}

export interface DashboardDto {
	productCount: number;
	productActiveCount: number;
	
	sdkCount: number;
	sdkActiveCount: number;
	
	productPackageCount: number;
	productPackageActiveCount: number;

	driveFileCount: number;
}

export interface GoogleFileDto {
	id: string;
	createdTime?: Date;
	modifiedTime?: Date;
	name: string;
	originalFilename: string;
	mimeType: string;
	description?: string;
	driveId?: string;
	fileExtension?: string;
	kind?: string;
	lastModifyingUser?: GoogleUserDto;
	size?: number;
	version?: number;
	webViewLink?: string;
}

export interface GoogleUserDto {
	displayName?: string;
	emailAddress?: string;
}

export interface Breadcrumb {
    id?: string;
    name?: string;
}

export interface GoogleFileRequestDto {
	folderId?: string;
	packageFiles?: GoogleFileDto[];
}

export enum ProductStatusEnum {
	Active = "Active",
	Disabled = "Disabled",
}

export interface ProductDto {
	id?: number;
	createdAt?: Date;
    name?: string;
    description?: string;
	brochureDriveFile?: DriveFileDto;
	hasBrochure?: boolean;
	datasheetDriveFile?: DriveFileDto;
	hasDatasheet?: boolean;
    logoDriveFile?: DriveFileDto;
	logoBase64?: string;
	hasLogo?: boolean;
    link?: string;
    status?: ProductStatusEnum;
	packageCount?: number;
}

export interface SdkCategoryDto {
	id?: number;
	createdAt?: Date;
    name?: string;
    description?: string;
	colour?: string;
}

export interface SdkVendorDto {
	id?: number;
	createdAt?: Date;
    name?: string;
    description?: string;
	colour?: string;
}

export interface DriveFileDto {
	id?: number;
	createdAt?: Date;
	driveFileId?: string;
    driveFolderId?: string;
    driveFileName?: string;
    driveFileLink?: string;
}

export enum SdkStatusEnum {
	Active = "Active",
	Disabled = "Disabled",
}

export enum SdkPlatformEnum {
	Windows = "Windows",
	Android = "Android",
	Linux = "Linux"
}

export enum SdkAssetTypeEnum {
	Documentation = "Documentation", 
	Demo = "Demo",
	Lib = "Lib",
	Src = "Src",
}

export interface SdkAssetDto {
	id?: number;
	createdAt?: Date;
	assetType?: SdkAssetTypeEnum;
	driveFile?: DriveFileDto;
}

export interface SdkDto {
	id?: number;
	createdAt?: Date;
	category?: SdkCategoryDto;
	vendor?: SdkVendorDto;
    name?: string;
    description?: string;
	platforms?: SdkPlatformEnum[];
    status?: SdkStatusEnum;
	assets?: SdkAssetDto[];
	driveLink?: string;
	expand?: boolean;
}

export enum MediaTypeEnum {
	ProductBrochurePdf = "ProductBrochurePdf",
	ProductDatasheetPdf = "ProductDatasheetPdf",
	ProductImage = "ProductImage",
}

export interface BreadcrumbDto {
	id?: string;
	name?: string;
}

export interface ProductPackageDto {
    id?: number;
    product?: ProductDto;
    name?: string;
    description?: string;
    status?: ProductStatusEnum;
    sdks?: SdkDto[];
}

export interface EmailDataDto {
	id: number;
	customerName: string;
	customerEmail: string;
	customerCcEmail: string;
	ccSales: boolean;
	ccSupport: boolean;
	expiry: number;
	packages: ProductPackageDto[];
}

export interface EmailQueueSearchDto {
	start?: Date;
	end?: Date;
	customerName?: String;
	customerEmail?: String;
	packages?: ProductPackageDto[];
}

export interface DownloadTrackerDto {
    id?: number;
    downloadToken?: DownloadTokenDto;
    downloadedAt?: Date;
    reported?: boolean;
}

export interface DownloadTokenDto {
    id?: number;
    uuid?: string;
    createdAt?: Date;
    expiresAt?: Date;
    password?: string;
    sdk?: SdkDto;
    driveFile?: DriveFileDto;
    emailQueue?: EmailQueueDto;
    downloadCount?: number;
}

export interface EmailQueueDto {
	id?: number;
	createdAt?: Date;
	customerName?: string;
	customerEmail?: string;
	customerCcEmail?: string;
	ccSales?: Boolean;
	ccSupport?: Boolean;
	rawPassword?: string;
	expiry?: number;
	status?: EmailQueueStatusEnum;
	error?: string;
	productPackages?: EmailProductPackageDto[];
}

export interface EmailProductPackageDto {
    id?: number;
    productPackage?: ProductPackageDto;  
}

export enum EmailQueueStatusEnum {
	Draft = "Draft",
	Pending = "Pending",
	InProgress = "InProgress",
	Complete = "Complete",
	Failed = "Failed",
}

export interface GenerateLinksRequestDto {
	packageIds: number[];
}
export interface GenerateLinksResponseDto {
    packages: ProductPackageDto[];
    generatedPassword: string;
	emailId: number;
}

export interface UserPermissionPayloadDto {
	userId: number;
	permissionIds: number[];
}